define((require) => {
    "use strict";

    var Class                  = require("shared/util/Class"),
        SalesforceCommerceOCAPIService = require("ui/experience/widgets/salesforceCommerceWidget/service/SalesforceCommerceOCAPIService");

    /**
     * @class {SalesforceCommerceOCAPIServiceFactory}
     *
     * Factory for SalesforceCommerce services.
     *
     * @author Pedro Augusto/ <a href="http://www.zmags.com">Zmags</a>
     */
    var SalesforceCommerceOCAPIServiceFactory = Class.extend("SalesforceCommerceOCAPIServiceFactory", {

        /**
         * Get an instance of the <tt>SalesforceCommerceOCAPIService</tt> according with the SalesforceCommerce version.<p>
         *
         * There is a basic implementation called <tt>SalesforceCommerceOCAPIService</tt> inside of the folder service.
         * However, IF in future, SalesforceCommerce drastically changes the way how they expose them
         * service, we can create a new folder version and extend the classes <tt>SalesforceCommerceDataAdapter</tt>
         * and <tt>SalesforceCommerceOCAPIService</tt>.
         *
         * @return {SalesforceCommerceOCAPIService} The SalesforceCommerce service.
         */
        getService: function() {
            return SalesforceCommerceOCAPIService;
        }
    });

    return new SalesforceCommerceOCAPIServiceFactory();
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/service/SalesforceCommerceOCAPIServiceFactory.js